export const WEIGHT_QUESTIONS = {
  safety: {
    id: 'safety',
    number: 1,
    text: 'First, let\'s confirm, do you currently have any of the following conditions?',
    hint: 'For your health and safety, we need to know these first',
    type: 'checkbox',
    options: [
      { value: 'pregnant', label: '🤰 Pregnant or breastfeeding' },
      { value: 'diabetes', label: '💉 Have diabetes or thyroid disease' },
      { value: 'medication', label: '💊 Taking diet pills or meal replacements' },
      { value: 'eating_disorder', label: '🚫 Have eating disorders (anorexia, bulimia, etc.)' },
      { value: 'none', label: '✓ None of the above, continue', exclusive: true }
    ]
  },
  
  demographics: {
    id: 'demographics',
    number: 2,
    text: 'Tell us some basic information',
    type: 'multi-part',
    parts: [
      {
        id: 'age',
        label: 'Age Group',
        type: 'radio',
        options: [
          { value: '18-35', label: '18-35 years' },
          { value: '36-50', label: '36-50 years' },
          { value: '51-65', label: '51-65 years' },
          { value: 'other', label: 'Other age group' }
        ]
      },
      {
        id: 'height',
        label: 'Height',
        type: 'radio',
        options: [
          { value: '<160', label: '160cm below (5\'3" below)' },
          { value: '160-170', label: '160-170cm (5\'3"-5\'7")' },
          { value: '170-180', label: '170-180cm (5\'7"-5\'11")' },
          { value: '>180', label: '180cm above (5\'11" above)' }
        ]
      },
      {
        id: 'weight',
        label: 'Current Weight',
        type: 'radio',
        options: [
          { value: '<50', label: '50kg below (110 lbs below)' },
          { value: '50-60', label: '50-60kg (110-132 lbs)' },
          { value: '60-70', label: '60-70kg (132-154 lbs)' },
          { value: '70-80', label: '70-80kg (154-176 lbs)' },
          { value: '80-90', label: '80-90kg (176-198 lbs)' },
          { value: '>90', label: '90kg above (198 lbs above)' }
        ]
      }
    ]
  },

  goal: {
    id: 'goal',
    number: 3,
    text: 'What is your weight loss goal?',
    type: 'radio',
    options: [
      { value: '5-10', label: '🎯 Want to lose 5-10 pounds (2.5-5kg)' },
      { value: '10-20', label: '🎯 Want to lose 10-20 pounds (5-10kg)' },
      { value: '>20', label: '🎯 Want to lose over 20 pounds (over 10kg)' }
    ]
  },

  mainIssue: {
    id: 'mainIssue',
    number: 4,
    text: 'What is your main concern?',
    hint: 'Select 1-2 that bother you the most',
    type: 'checkbox',
    maxSelect: 2,
    options: [
      { value: 'edema', label: '😓 Easily swollen, face and legs swollen in the morning' },
      { value: 'appetite', label: '🍽️ Appetite too good, always want to eat' },
      { value: 'constipation', label: '💩 Often constipated, difficult bowel movements' },
      { value: 'fatigue', label: '😴 Easily fatigued, don\'t like to move' }
    ]
  },

  edemaTime: {
    id: 'edemaTime',
    number: 5,
    text: 'When is edema usually noticeable？',
    type: 'radio',
    condition: (answers) => answers.mainIssue?.includes('edema'),
    options: [
      { value: 'morning', label: '🌅  When waking up in the morning' },
      { value: 'evening', label: '🌆  Afternoon/Evening' },
      { value: 'allday', label: '⏰  All day long' }
    ]
  },

  appetiteType: {
    id: 'appetiteType',
    number: 5,
    text: 'How is your appetite?',
    type: 'radio',
    condition: (answers) => answers.mainIssue?.includes('appetite'),
    options: [
      { value: 'meals', label: '🍚 Eat a lot at main meals' },
      { value: 'snacks', label: '🍿 Always want to eat snacks' },
      { value: 'sweet_oily', label: '🍰 Especially like sweet/oily foods' }
    ]
  },

  dietHabits: {
    id: 'dietHabits',
    number: 6,
    text: 'Your eating habits?',
    hint: 'Select all that apply',
    type: 'checkbox',
    options: [
      { value: 'heavy_taste', label: '🧂 Taste preference is heavy (salt/sweet/oily)' },
      { value: 'cold_drinks', label: '🧊 Love to drink cold drinks' },
      { value: 'eat_out', label: '🍔 Eat out frequently' },
      { value: 'fast_eating', label: '⚡ Eat fast' },
      { value: 'healthy', label: '🥗 Eat healthy' }
    ]
  },

  exercise: {
    id: 'exercise',
    number: 7,
    text: 'Exercise frequency?',
    type: 'radio',
    options: [
      { value: 'none', label: '🛋️ Almost no exercise' },
      { value: 'occasional', label: '🚶 Occasionally (1-2 times per week)' },
      { value: 'regular', label: '🏃 Regularly (3+ times per week)' }
    ]
  },

  previousAttempts: {
    id: 'previousAttempts',
    number: 8,
    text: 'What have you tried before?',
    hint: 'Select all that apply',
    type: 'checkbox',
    options: [
      { value: 'diet', label: '🥗 Dieting' },
      { value: 'exercise', label: '🏋️ Exercise' },
      { value: 'pills', label: '💊 Diet pills/meal replacements' },
      { value: 'tcm', label: '🌿 TCM conditioning' },
      { value: 'none', label: 'Haven\'t tried yet', exclusive: true }
    ]
  },

  constitution: {
    id: 'constitution',
    number: 9,
    text: 'Do you usually have these conditions?',
    hint: 'Select all that apply',
    type: 'checkbox',
    options: [
      { value: 'cold_limbs', label: '🧊 Hands and feet are cold' },
      { value: 'sweating', label: '💦 Easily sweat' },
      { value: 'thirsty', label: '💧 Dry mouth/thirsty' },
      { value: 'loose_stool', label: '💩 Loose stool (diarrhea)' },
      { value: 'none', label: 'None of the above', exclusive: true }
    ]
  }
};